<template>
  <div class="exercises-filters">
    <!-- <v-btn 
      icon 
      text 
      @click="filterType('EXERCISE', !exercise)" 
      :class="exercise ? 'active' : ''"
      v-if="!advancedSearchActive"
      class="with-hover"
    >
      <v-icon size="24">bhi-exercise</v-icon>
      <span class="hidden">Single Exercise</span>
    </v-btn>
    <v-btn 
      icon 
      text 
      @click="filterType('SERIES', !series)" 
      :class="series ? 'active' : ''"
      v-if="!advancedSearchActive"
      class="with-hover"
    >
      <v-icon size="24">bhi-list</v-icon>
      <span class="hidden">Circuit</span>
    </v-btn>
    <v-btn 
      icon 
      :text="!activity" 
      @click="filterType('ACTIVITY', !activity)" 
      :class="activity ? 'active' : ''"
      :disabled="advancedSearchActive"
      class="with-hover"
    >
      <v-icon size="24">bhi-activity</v-icon>
      <span class="hidden">Activity</span>
    </v-btn> -->
    <v-text-field
      :value="value"
      class="bh-input-pill rounded-pill"
      color="accent"
      height="48px"
      width="200px"
      append-icon="bhi-loupe"
      placeholder="Search for Activities"
      filled
      clearable
      hide-details
      v-if="!advancedSearchActive"
      @input="onInput('query', $event)"
      @click:clear="clearSearch"
      @click:append="runSearch"
      @keydown.enter="runSearch"
    ></v-text-field>
<!--     <v-btn 
      v-if="advancedSearchActive" 
      rounded
      class="transparent"
      text 
      color="bhRed" 
      @click="clearFilters"
    >
      Clear filters
      <v-icon class="pl-2">bhi-close-circle</v-icon>
    </v-btn>
    <v-btn 
      :color="advancedSearchActive ? 'bhRed': 'accent'" 
      text 
      rounded 
      @click="openAdvancedSearch"
    >
      Advanced search
      <v-icon class="pl-2">bhi-filter</v-icon>
    </v-btn> -->
  </div>
</template>
<script>
import { debounce } from "@/helpers/debounce"
export default {
  name: "ExercisesFilters",
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    activityTime: {
      type: [Boolean, String],
      default: false
    },
    advancedSearchActive: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tmpValue: '',
    multipleInputs: [],
    exercise: false,
    series: false,
    activity: false,
    time: false,
  }),
  watch: {
    type(val) {
      let arr = []
      if (val) arr = val.split(',')
      this.exercise = false
      this.series = false
      this.activity = false
      if (arr.length>0) {
        arr.forEach(item=>{
          switch (item) {
            case 'EXERCISE':
              this.exercise = true
              break
            case 'SERIES':
              this.series = true
              break
            case 'ACTIVITY':
              this.activity = true
              break
          }
        })
      }
    },
    activityTime(val) {
      this.time = val
    }
  },
  computed: {
    typeComputed() {
      let arr = []
      if (this.exercise) arr.push('EXERCISE')
      if (this.series) arr.push('SERIES')
      if (this.activity) arr.push('ACTIVITY')
      return arr.join(',')
    }
  },
  created() {
    switch (this.type) {
      case 'EXERCISE':
        this.exercise = true
        break
      case 'SERIES':
        this.series = true
        break
      case 'ACTIVITY':
        this.activity = true
        break
      default:
        break
    }
    if (this.activityTime) this.time = this.activityTime
    if (this.value) this.tmpValue = this.value
  },
  methods: {
    clearSearch() {
      this.tmpValue = ''
      this.$emit('search-on:clear')
    },
    runSearch() {
      if (this.tmpValue)
        this.$emit('search-run', this.tmpValue)
    },
    onInput (key, value) {
      if (key == 'query') this.tmpValue = value
      debounce(() => {
        this.$emit('search-on:input', { key, value })
      },1000, 'ExercisesFilters')
    },
    onMultiple (key, value) {
      this.multipleInputs.push({key: key, value: value})
      debounce(() => {
        this.$emit('search-on:multiple', this.multipleInputs)
        this.multipleInputs = []
      },1000, 'ExercisesFilters')
    },
    filterActivityTime(name) {
      if (this.time == name) {
        this.time = null
      }
      else {
        this.time = name
        this.activity = true
      }

      this.onMultiple('type', 'ACTIVITY')
      this.onMultiple('activityTime', this.time)
    },
    filterType(name, value) {
      // // allow filtering by multiple types:
      // switch (name) {
      //   case 'EXERCISE':
      //     this.exercise = value
      //     break
      //   case 'SERIES':
      //     this.series = value
      //     break
      //   case 'ACTIVITY':
      //     this.activity = value
      //     if (!value) this.time = null
      //     break
      // }
      // this.onInput('type', this.typeComputed)
      // // end here
      // allow filtering by single type:
      let type = ''
      if (value) type = name
      switch (name) {
        case 'EXERCISE':
          this.exercise = value
          this.series = false
          this.activity = false
          this.time = null
          this.onMultiple('type', type)
          this.onMultiple('activityTime', null)
          break
        case 'SERIES':
          this.series = value
          this.exercise = false
          this.activity = false
          this.time = null
          this.onMultiple('type', type)
          this.onMultiple('activityTime', null)
          break
        case 'ACTIVITY':
          this.activity = value
          if (!value) this.time = null
          this.series = false
          this.exercise = false
          this.onMultiple('type', type)
          this.onMultiple('activityTime', this.time)
          break
      }
      // end
    },
    openAdvancedSearch() {
      this.time = null
      this.exercise = false
      this.activity = false
      this.series = false
      this.onMultiple('type', null)
      this.onMultiple('activityTime', null)
      this.$emit('open-advanced-search')
    },
    clearFilters() {
      this.time = null
      this.exercise = false
      this.activity = false
      this.series = false
      this.$emit('clear-filters')
    }
  }
};
</script>
<style lang="scss">
.exercises-filters {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .v-btn {
    &.with-hover {
      transition-duration: 300ms !important;
      transition-property: box-shadow, transform, width, opacity;
      width: 48px;
      justify-content: flex-start;
      overflow: hidden;
      border-radius: 999px;
      &:hover {
        width: 160px;
        .hidden {
          opacity: 1;
        }        
      }
      .hidden {
        position: absolute;
        left:40px;
        transition-duration: 300ms;
        width: 100px;
        text-align: center;
        pointer-events: none;
        opacity: 0;
      }
      .v-icon {
        width: 48px;
      }
    }
    &.active {
      background: $bh-blue !important;
      .hidden {
        color: $bh-white;
      }
      .v-icon {
        &::before {
          color: $bh-white;
        }
      }
      small {
        color:$bh-white;
      }
    }
    &.transparent {
      background: transparent !important;
    }
    &--disabled {
      opacity: 0.3;
    }
  }
}
.bh-input-pill {
  margin: 0 8px !important;
  width: 264px;
  height: 48px !important;
  &.v-input--is-disabled {
    opacity: 0.3;
  }
  .v-input__slot {
    align-items: center;
    height: 48px;
    min-height: 0 !important;
    background:$bh-gray--6 !important;

    &::before,
    &::after {
      content: "";
      display: none;
    }

    .v-input__append-inner {
      align-self: center;
      margin-top: 0 !important;
    }

    .v-icon {
      color: $bh-blue;
    }
  }
}
</style>
